import * as Actions from "../actions/creators";
import Validation from '../../../common/utils/validation'

class SignIn {
  constructor(props, componentProps, dispatch, selectors, t, redux = {}) {
    this.name = "SignIn";
    this.props = props;
    this.dispatch = dispatch;
    this.componentProps = componentProps;
    this.redux = redux;
    this.t = t;
    this.selectors = selectors;

    if (props && props.onMount) {
      this.onMount();
    }
  }

  onMount() {
    this.props.onMount();
  }

  startLogin(state) {
    let rules = {
        email : { 
            required : true,
            type: 'email'
        },
        password : { 
            required : true,
            minLength: 6
        },
    };
    let validationResult = Validation.validateData(rules, state.data);
    if(validationResult.valid) {
        this.dispatch(Actions.startLogin({ ...state.data }));
    }
    return validationResult
  }
}

export default SignIn;
